import script from "./my-dateToDate.vue?vue&type=script&setup=true&lang=js"
export * from "./my-dateToDate.vue?vue&type=script&setup=true&lang=js"

import "./my-dateToDate.vue?vue&type=style&index=0&id=0bc45f2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc45f2a"]])

export default __exports__